import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import { axiosClient, queryClient } from "../../clients";

import type { IMemberLaboratories } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { useGetAllMemberLaboratories } from "@/api/members/laboratories/getAll";
import { useGetMemberLaboratory } from "@/api/members/laboratories/get";

const { getPath } = getApi("members.laboratories.post");

type IExtractedRouteType = IMemberLaboratories["laboratoryCreate"];

export type IPostMemberLaboratory = IPickMutation<IExtractedRouteType>;

const postMemberLaboratory: MutationFunction<
  IPostMemberLaboratory["response"],
  IPostMemberLaboratory["variables"]
> = ({ memberId, ...data }) => {
  return axiosClient.post(getPath({ memberId }), data);
};

export const usePostMemberLaboratory = createMutation({
  mutationFn: postMemberLaboratory,
  onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratories.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratory.getKey(),
    });
  },
});
